import { ContactUsInitialState, ContactUsState, ReduxAction } from "../models";
import { ContactUsTypes } from "../types";

export const ContactState = (state: ContactUsState = ContactUsInitialState, action?: ReduxAction): ContactUsState => {
    if (!action) return state;

    switch (action.type) {
        case ContactUsTypes.SUBMIT_CONTACT_US:
            return { ...state, loading: true, succeed: false };
        case ContactUsTypes.CONTACT_US_SUBMITTED:
            return { ...state, loading: false, succeed: action.payload };
        case ContactUsTypes.SET_FEEDBACK_TYPES:
            return { ...state, types: action.payload, typesLoaded: action.payload && action.payload.length };
    }

    return state;
};
